import "./index.less";
import React, { CSSProperties, FC, HTMLAttributes, PropsWithChildren } from "react";
import cs from "classnames";

export interface AvatarUIProps
  extends PropsWithChildren<HTMLAttributes<HTMLSpanElement>> {
  size?: number | string;
}

const getSizeStyle = (size?: AvatarUIProps["size"]): CSSProperties => {
  if (size === undefined) {
    return {};
  }

  const resolvedSize = typeof size === "number" ? `${size}px` : size;

  return {
    width: resolvedSize,
    height: resolvedSize,
    lineHeight: resolvedSize,
    fontSize: resolvedSize,
  };
};

const AvatarUI: FC<AvatarUIProps> = ({
  children,
  className,
  size,
  style,
  ...restProps
}) => {
  return (
    <span
      {...restProps}
      className={cs("avatar-ui", className)}
      style={{ ...getSizeStyle(size), ...style }}
    >
      {children}
    </span>
  );
};

export default AvatarUI;
